import Decimal from "decimal.js";

export default function formatNumber(num, type = "thousand") {
  if (num === null || num === undefined || num === "") return "0";

  // remove commas if string input
  const clean = String(num).replace(/,/g, "");

  // ---------- DECIMAL ----------
  if (type === "decimal") {
    const value = new Decimal(clean).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
    return value.toFixed(2);
  }

  // ---------- ALPHABET (k, M, B...) ----------
  if (type === "alphabet") {
    const units = ["k", "M", "B", "T", "P", "E", "Z", "Y"];
    const value = new Decimal(clean);

    for (let i = units.length - 1; i >= 0; i--) {
      const decimal = new Decimal(1000).pow(i + 1);

      if (value.abs().gte(decimal)) {
        const number = value
          .div(decimal)
          .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
        return `${number.toFixed()}${units[i]}`;
      }
    }

    return value.toDecimalPlaces(2).toFixed();
  }

  // ---------- RANGE ----------
  if (type === "range") {
    if (typeof num === "string" && num.includes("-")) {
      const [min, max] = num.split("-");

      const minVal = new Decimal(min).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
      const maxVal = new Decimal(max).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

      return `${minVal.toFixed(2)} - ${maxVal.toFixed(2)}`;
    }

    const value = new Decimal(clean).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

    return value.toNumber().toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  // ---------- DEFAULT THOUSAND ----------
  const value = new Decimal(clean);
  const rounded = value.toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

  const hasDecimal = !rounded.mod(1).equals(0);

  return rounded
    .toNumber()
    .toLocaleString(
      undefined,
      hasDecimal
        ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        : { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    );
}
